import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import './StyledCard.css';

/**
 * StyledCard - Reusable card component with hover effects
 * Following the EvaluationList design pattern
 */
const StyledCard = ({
    children,
    className = '',
    hoverable = true,
    variant = 'default',
    ...props
}) => {
    const cardClass = `styled-card ${hoverable ? 'hoverable' : ''} ${variant} ${className}`;

    return (
        <Card className={cardClass} {...props}>
            {children}
        </Card>
    );
};

StyledCard.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    hoverable: PropTypes.bool,
    variant: PropTypes.oneOf(['default', 'instance', 'empty'])
};

export default StyledCard;